import React from 'react';

// Map-like pin icon used by the BookmarksScrubber progress indicator.
// Uses currentColor so the parent can colour it via Tailwind text-* classes.
const MapPinIcon = ({ className = 'h-6 w-6' }) => (
  <svg
    viewBox="0 0 24 24"
    className={`${className} fill-current`}
    aria-hidden="true"
  >
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
  </svg>
);

export default MapPinIcon;
